const buildTimeConfig = Object.freeze({
  BASE_URL: process.env.BASE_URL || "/",
  VUE_APP_API_URL: process.env.VUE_APP_API_URL || "",
  VUE_APP_CRYPTO_API_URL: process.env.VUE_APP_CRYPTO_API_URL || "",
  VUE_APP_AUTH_SCHEME: process.env.VUE_APP_AUTH_SCHEME || "Bearer",
  VUE_APP_ALERTS_WS_BASE_URL: process.env.VUE_APP_ALERTS_WS_BASE_URL || "",
  VUE_APP_WIDGET_TOKEN: process.env.VUE_APP_WIDGET_TOKEN || "",
  VUE_APP_WIDGET_DEBUG: process.env.VUE_APP_WIDGET_DEBUG || "0",
  VUE_APP_YOUTUBE_API_KEY: process.env.VUE_APP_YOUTUBE_API_KEY || "",
  VUE_APP_GOOGLE_OAUTH_CLIENT_ID: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID || "",
  VUE_APP_GOOGLE_OAUTH_REDIRECT_URI: process.env.VUE_APP_GOOGLE_OAUTH_REDIRECT_URI || "",
  VUE_APP_GOOGLE_OAUTH_SCOPE: process.env.VUE_APP_GOOGLE_OAUTH_SCOPE || "",
  VUE_APP_TWITCH_OAUTH_CLIENT_ID: process.env.VUE_APP_TWITCH_OAUTH_CLIENT_ID || "",
  VUE_APP_TWITCH_OAUTH_REDIRECT_URI: process.env.VUE_APP_TWITCH_OAUTH_REDIRECT_URI || "",
  VUE_APP_TWITCH_OAUTH_SCOPE: process.env.VUE_APP_TWITCH_OAUTH_SCOPE || "",
});

function getRuntimeConfig() {
  if (typeof window === "undefined") {
    return {};
  }

  return window.__APP_CONFIG__ || {};
}

export function getAppConfig(key) {
  const runtimeValue = getRuntimeConfig()[key];

  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== "") {
    return runtimeValue;
  }

  return buildTimeConfig[key] ?? "";
}

export function getBaseUrl() {
  return String(getAppConfig("BASE_URL") || "/").trim() || "/";
}

export function getApiBaseUrl() {
  return String(getAppConfig("VUE_APP_API_URL") || "")
    .trim()
    .replace(/\/+$/, "");
}

/** Базовый URL крипто-сервиса (GET/POST …/api/v1/payments/…). */
export function getCryptoApiBaseUrl() {
  return String(getAppConfig("VUE_APP_CRYPTO_API_URL") || "")
    .trim()
    .replace(/\/+$/, "");
}

export function getAuthScheme() {
  return String(getAppConfig("VUE_APP_AUTH_SCHEME") || "Bearer").trim() || "Bearer";
}

export function getAlertsWsBaseUrl() {
  return String(getAppConfig("VUE_APP_ALERTS_WS_BASE_URL") || "").trim();
}

export function getWidgetToken() {
  return String(getAppConfig("VUE_APP_WIDGET_TOKEN") || "").trim();
}

export function isWidgetDebugEnabled() {
  return String(getAppConfig("VUE_APP_WIDGET_DEBUG") || "") === "1";
}

export function getYoutubeApiKey() {
  return String(getAppConfig("VUE_APP_YOUTUBE_API_KEY") || "").trim();
}
